module.exports = __webpack_public_path__ + "e47b3df0df89ed4414775884e387eebb.svg";